import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import { useSelector } from "react-redux";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";


function Settings() {
  const { t } = useTranslation();

  const {
    data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed },
  } = useSelector(({ walletSetting }) => walletSetting);

  const getMappedListRes = useSelector(
    ({ getMappedList }) => getMappedList
  );

  const history = useHistory();
  const { pathname } = useLocation();
	const Theme = useSelector((state) => state.theme.theme);

  const options = [
    {
      id: 1,
      label: "Configuration",
      route: "/index/configration",
      src: `${process.env.PUBLIC_URL}/${Theme}/kyc configration1.png`,
      flag: "CONFIGURATION",
    },
    {
      id: 2,
      // label: "My Banks",
      label: "Module Allocation",
      route: "/index/moduleAllocation",
      src: `${process.env.PUBLIC_URL}/${Theme}/kyc report.png`,
      flag: "MODULE ALLOCATION",
    },
    {
      id: 3,
      label: "Wallet Owner Bank",
      route: "/index/wallet-owner-bank",
      src: `${process.env.PUBLIC_URL}/${Theme}/MyBank.png`,
      flag: "WALLET OWNER BANKS",
    },
    {
      id: 4,
      label: "Bank Master",
      route: "/index/PartnerBankMaster",
      src: `${process.env.PUBLIC_URL}/${Theme}/MyBank.png`,
      flag: "WALLET OWNER BANKS",
    },
    {
      id: 5,
      label: "Activity Tracker",
      route: "/index/ActivityTracker",
      src: `${process.env.PUBLIC_URL}/${Theme}/CREATE PROOF TYPE.png`,
      flag: "ACTIVITY TRACKER",
    },
    {
      id: 6,
      label: "Ip Whitelisting",
      route: "/index/ipWhitelisting",
      src: `${process.env.PUBLIC_URL}/${Theme}/CREATE PROOF TYPE.png`,
      flag: "IP WHITELIST",
    },
    

  
  
  ];
  
  const filteredOptns = options.filter(({ label }) => {
    // if (
    //   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
    // ) {
    //   return label !== "My Cards";
    // }
    // else if (
    //   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
    // )
    // {
    //   return label !== "My Banks";
    // }
    if (
      label === "My Wallets" &&
      !constants.visibleFlags.includes(isMyWalletAllowed)
    ) {
      // return label !== "My Wallets";
    } else return true;
  });
  // .sort((a, b) => {
  //   return a.label > b.label ? 1 : -1;
  // });

  if (!filteredOptns.length) {
    return (
      <Layout>
        <Card className="mk-root">
          <Row className="mk-row m-auto">No My Accounts Available</Row>
        </Card>
      </Layout>
    );
  }

  const handleRoute = (route) => {
    history.push({ pathname: route, state: { from: pathname } });
  };

  return (
    <Layout>
      <Card className="mk-root">
        <Row className="mk-row">
          {options.map(({ id, src, label, route, flag }) => {
            if (
              getMappedListRes.success &&
              getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
            ) {
              return (<Col key={id} md={4} sm={4} xs={6}>
                <div className="mk-imageRoot" onClick={() => handleRoute(route)}>
                  <div className="mk-imageContainer">
                    <img className="mk-image" src={src} alt={label} />
                  </div>
                  <Label for={label} className="fs-14">
                    {t(label)}
                  </Label>
                </div>
              </Col>)
            }
          })}
        </Row>
      </Card>
    </Layout>
  );
}

export default Settings;
